import React from "react";

import CarSearchFiltersForm from "./CarSearchFiltersForm";

const CarSearchFormMobile: React.FC = () => {
    return <CarSearchFiltersForm variant="mobile" />;
};

export default CarSearchFormMobile;
